// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__3VGf8","panelRow":"Panel_panelRow__6kRPE","fluid":"Panel_fluid__2KZth","panelHighlighted":"Panel_panelHighlighted__2uz8J","blink":"Panel_blink__-bpQl"};